import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
// import "bootstrap/dist/css/bootstrap.min.css";

import { Outlet } from "react-router-dom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LandingPage from "./Pages/LandingPage";
import AboutUs from "./Pages/AboutUsPage";
import ContactPage from "./Pages/ContactPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PrivacyCookiePage from "./Pages/PrivacyCookiePage";
import DigitalAccessability from "./Pages/DigitalAccessabilityPage";
import DisclaimerPage from "./Pages/DisclaimerPage";

function Root() {
  return (
    <>
      <main>
        <Header />
        <div className="main">
          <Outlet />
        </div>
        <Footer />
      </main>
    </>
  );
}

function App() {
  const router = createBrowserRouter([
    {
      children: [
        {
          element: <LandingPage />,
          path: "/",
        },
        {
          element: <AboutUs />,
          path: "/aboutRozWon",
        },
        { element: <ContactPage />, path: "/contactUs" },
        { element: <PrivacyCookiePage />, path: "/privacypolicy" },
        { element: <DigitalAccessability />, path: "/digitalaccessibility" },
        { element: <DisclaimerPage />, path: "/disclaimer" },
      ],
      element: <Root />,
    },
  ]);

  return (
    <>
      <RouterProvider router={router}>
        <div>
          <Outlet />
        </div>
      </RouterProvider>
    </>
  );
}

export default App;
